import { render } from "./GestionePratiche.vue?vue&type=template&id=47c4c4bc"
import script from "./GestionePratiche.vue?vue&type=script&lang=js"
export * from "./GestionePratiche.vue?vue&type=script&lang=js"

import "./GestionePratiche.vue?vue&type=style&index=0&id=47c4c4bc&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__